import { capitalize } from '@mui/material';
import { CloudAccountType } from '@repo/api-gw-sdk';
import { useState, type Dispatch, type SetStateAction } from 'react';

export const useAccountRoleName = (
  accountType: CloudAccountType
): [string, Dispatch<SetStateAction<string>>] => {
  const [roleName, setRoleName] = useState<string>(
    accountType === CloudAccountType.Vault
      ? 'EonVaultVerificationRole'
      : `Eon${capitalize(accountType.toLowerCase())}AccountRole`
  );
  return [roleName, setRoleName];
};
